import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { connect as _connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { inputsSelector, formSelector } from './selectors';
import getInputProps from './getInputProps';
import { bindActions } from '../actions';

function applyMapDispatchToProps(mapDispatchToProps, dispatch, ownProps) {
  if (typeof mapDispatchToProps === 'function') {
    return mapDispatchToProps(dispatch, ownProps);
  } else {
    return bindActionCreators(mapDispatchToProps, dispatch);
  }
}
/**
 * Creates a function that works like react-redux `connect`, but adds a prop: *`inputProps`*
 * which contains the props for each input specified in the inputConfig.
 * This is generated with redux-inputs's `getInputProps` function.
 *
 * @param inputConfig {Object}
 * @param options
 *      options.inputPropsKey {String}
 *      options.inputActionsKey {String}
 * @returns `connect` function
 */


export default (function (inputConfig, mapReduxInputsToProps) {
  var connect = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _connect;

  var mapReduxInputsFn = mapReduxInputsToProps || function (reduxInputs) {
    return {
      reduxInputs: reduxInputs
    };
  };

  var inputActions = bindActions(inputConfig);
  return function (mapStateToProps) {
    var mapDispatchToProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (dispatch) {
      return {
        dispatch: dispatch
      };
    };
    var mergeProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (stateProps, dispatchProps, ownProps) {
      return _objectSpread({}, stateProps, {}, dispatchProps, {}, ownProps);
    };
    var connectOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    return function (Component) {
      return connect(function (state, ownProps) {
        return _objectSpread({
          _reduxInputsState: inputsSelector(inputConfig)(state),
          // Temporary prop to pass down to merge
          _reduxInputsForm: formSelector(inputConfig)(state)
        }, mapStateToProps && mapStateToProps(state, ownProps));
      }, function (dispatch, ownProps) {
        return _objectSpread({
          _getInputProps: function _getInputProps(inputs) {
            return getInputProps(inputConfig, inputs, dispatch);
          },
          // Temporary
          _reduxInputsActions: bindActionCreators(inputActions, dispatch)
        }, mapDispatchToProps && applyMapDispatchToProps(mapDispatchToProps, dispatch, ownProps));
      }, function (_ref, // stateProps
      _ref2, // dispatchProps
      ownProps) {
        var _getInputProps = _ref2._getInputProps,
            _reduxInputsActions = _ref2._reduxInputsActions,
            dispatchProps = _objectWithoutProperties(_ref2, ["_getInputProps", "_reduxInputsActions"]);

        var _reduxInputsState = _ref._reduxInputsState,
            _reduxInputsForm = _ref._reduxInputsForm,
            stateProps = _objectWithoutProperties(_ref, ["_reduxInputsState", "_reduxInputsForm"]);

        return _objectSpread({}, mapReduxInputsFn(_objectSpread({}, _reduxInputsForm, {}, _reduxInputsActions, {
          // setInputs, updateAndValidate, validateInputs, resetInputs, initializeInputs
          inputProps: _getInputProps(_reduxInputsState) // Use temporary props to create inputProps

        })), {}, mergeProps(stateProps, dispatchProps, ownProps));
      }, connectOptions)(Component);
    };
  };
});